import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M22.75 12a.75.75 0 1 1-1.5 0V7.81l-7.22 7.22a.75.75 0 0 1-1.06 0L8.5 10.56l-5.97 5.97a.75.75 0 1 1-1.06-1.06l6.5-6.5.056-.052a.75.75 0 0 1 1.004.052l4.47 4.47 6.69-6.69H16a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75z" />
  </>
);

const Activity = Icon('activity', svgContents);

export default Activity;
